export default __webpack_public_path__ + "static/media/hydrologicaldrought.f034e89b.png";